import PropTypes from "prop-types";
import React, { useState } from "react";
import withRouter from "components/Common/withRouter";
import { Col, Container, Modal, ModalHeader, Row } from "reactstrap";
import { Link } from "react-router-dom";
import LatestTransaction from "./GCPResource";
import Breadcrumbs from "../../components/Common/Breadcrumb";

const GCPResources = props => {
    const [gcpDeployModal, setGcpDeployModal] = useState(false);

    const cancelDeployModal = () => {
        setGcpDeployModal(false);
    }

    document.title = "GCPResources | Temperstack";

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Row>
                        <Col lg="8">
                            <Breadcrumbs
                                title={"GCP Resources"}
                                breadcrumbItem={"GCP Resources"}
                            />
                        </Col>
                        <Col lg="4">
                        </Col>
                        <Col lg="12">
                            <LatestTransaction />
                        </Col>
                    </Row>
                </Container>
            </div>
            <Modal
                isOpen={gcpDeployModal}
                role="dialog"
                autoFocus={true}
                keyboard={false}
                centered
                backdrop="static"
                data-toggle="modal"
            >
                <div>
                    <ModalHeader
                        className="border-bottom-0"
                    ></ModalHeader>
                </div>
                <div className="modal-body">
                    <div className="text-center mb-4">
                        <div className="row justify-content-center">
                            <div className="col-xl-10">
                                <h4 className="text-primary">Are you sure you want to deploy alerts?</h4>
                                <h5 className="mt-4">This will deploy the default thresholds for all your resources. Please review
                                    the <Link to="/thresholds" target="_blank">thresholds</Link> and modify if required.</h5>
                                <Row className="full-width">
                                    <Col lg="6" className="mt-4">
                                        <Link onClick={cancelDeployModal} className="btn btn-secondary w-md">Cancel</Link>
                                    </Col>
                                    <Col lg="6" className="mt-4">
                                        <Link to="/dashboard" className="btn btn-primary w-md">Deploy</Link>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </React.Fragment>
    );
};

GCPResources.propTypes = {
    history: PropTypes.object
};

export default withRouter(GCPResources);
